import React, { useMemo } from "react";
import { columnRenderArrayData } from "utils/tableUtils";

import GenericPullConfigListing from "../GenericPullConfigListing";
import PenTestToolCredentialsForm from "./PenTestToolCredentialsForm";
import PenTestToolMappingForm from "./PenTestToolMappingForm";

const PenTestToolConfigLising = (props) => {

  const columns = useMemo(
    () => [
      {
        title: "Workspace",
        dataIndex: "workspaceName",
        width: 130,
        render: columnRenderArrayData,
      },
      {
        title: "Assets",
        dataIndex: "assetName",
        width: 130,
        render: columnRenderArrayData,
      },
    ],
    [],
  );

  return (
    <GenericPullConfigListing
      {...props}
      toolName={props.name}
      MappingForm={PenTestToolMappingForm}
      CredentialsForm={PenTestToolCredentialsForm}
      extraColumns={columns}
    />
  );
};

export default PenTestToolConfigLising;